export default "__VITE_ASSET__c8f4eeb1__"